

import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { GoldAndRum_1Screen } from "../GoldAndRum/game_1Screen";

export class GoldAndRumLink_1Screen extends GoldAndRum_1Screen {
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "GoldAndRumLink");
    }
}